<!-- <div id="sidebar-collapse" class="sidebar">

    <div class="admin-block d-flex" style="align-items: center;">
        <div>
            <img src="./../../../assets/img/dash/advertisement.png" class="rounded-circle siderbar-img"/>
        </div>
        <div class="admin-info">
            <div class="font-strong" (click)="home()">{{auth.allSystemModuleObj['ADVERTISEMENT']}}</div>
        </div>
    </div>
    <ul class="side-menu metismenu">
        <li [hidden]="sidebar['dashbord']">
            <a class = "text-decoration-none"  routerLinkActive="active"  routerLink="/advertisement/advertisement-index"><i class="sidebar-item-icon fa fa-th-large"></i>
                <span class="nav-label"> Dashboard </span>
            </a>
        </li>
       <li [hidden]="sidebar['license_request']">
            <a class = "text-decoration-none"  routerLinkActive="active"  routerLink="/advertisement/license-request"><i class="sidebar-item-icon fa fa-user" aria-hidden="true"></i>
                <span class="nav-label"> License Request </span>
            </a>
        </li>
   
        <li routerLinkActive="active" >
            <a class="text-decoration-none" [hidden]="sidebar['administration']" href="#" data-bs-toggle="collapse" data-bs-target="#collapseAdmin"
            aria-expanded="false" aria-controls="collapseAdmin"><i class="sidebar-item-icon fa fa-database"></i>
                <span class="nav-label">Administration</span><i class="fa fa-angle-left arrow"></i></a>
            <ul  class="nav-2-level collapse" id="collapseAdmin" data-bs-parent="#sidebar-collapse" >
              <div id="adminParent">
                 <li>
                    <a   class="text-decoration-none" [hidden]="sidebar['master_data']" href="#" data-bs-toggle="collapse" data-bs-target="#set"
                    aria-expanded="false" aria-controls="set" >
                        <span class="nav-label">Master Data</span><i class="fa fa-angle-left arrow"></i></a>
                    <ul  class="nav-3-level collapse" id="set" data-bs-parent="#adminParent" >



                        <li >
                            <a routerLink="/advertisement/advertisement-setting/code-value" routerLinkActive="active">Code Value</a>
                        </li>
                        <li >
                            <a routerLink="/advertisement/advertisement-setting/field" routerLinkActive="active">Field</a>
                        </li>
                        <li >
                            <a routerLink="/advertisement/advertisement-setting/hierachy" routerLinkActive="active">
                                Hierachy
                            </a>
                        </li>

                    </ul>
                </li>

                <li>
                    <a  lass="text-decoration-none" [hidden]="sidebar['security']" href="#" data-bs-toggle="collapse" data-bs-target="#sec"
                    aria-expanded="false" aria-controls="sec" >
                        <span class="nav-label">Security</span><i class="fa fa-angle-left arrow"></i></a>
                    <ul class="nav-3-level collapse" id="sec" data-bs-parent="#adminParent" >
                        <li>
                            <a  routerLink="/advertisement/administration/roles"
                                routerLinkActive="active">
                                Role
                            </a>
                        </li>
                        <li>
                            <a  routerLink="/advertisement/administration/users"
                                routerLinkActive="active">User</a>
                        </li>
                        <li>
                            <a  routerLink="/advertisement/administration/data-assignment"
                                routerLinkActive="active">
                                Data Assignment
                            </a>
                        </li>
                        <li>
                            <a  routerLink="/advertisement/administration/workflow"
                                routerLinkActive="active">
                                Workflow
                            </a>
                        </li>
                    </ul>
                </li>
              </div>
            </ul>
        </li>

    </ul>
</div> -->
<div id="sidebar-collapse" class="sidebar">

    <div class="admin-block d-flex" style="align-items: center;">
        <div>
            <img src="./../../../assets/img/dash/advertisement.png" class="rounded-circle siderbar-img"/>
        </div>
        <div class="admin-info">
            <div class="font-strong" (click)="home()">{{auth.allSystemModuleObj['ADVERTISEMENT']}}</div>
        </div>
    </div>
    <ul class="side-menu metismenu">
        <li [hidden]="sidebar['dashbord']">
            <a class = "text-decoration-none"  routerLinkActive="active"  routerLink="/advertisement/advertisement-index"><i class="sidebar-item-icon fa fa-th-large"></i>
                <span class="nav-label"> Dashboard </span>
            </a>
        </li>
        <li [hidden]="sidebar['license_request']">
            <a class = "text-decoration-none"  routerLinkActive="active"  routerLink="/advertisement/license-request"><i class="sidebar-item-icon fa fa-user" aria-hidden="true"></i>
                <span class="nav-label"> License Request </span>
            </a>
        </li>
        <li [hidden]="sidebar['approved-license']">
            <a class = "text-decoration-none"  routerLinkActive="active"  routerLink="/advertisement/approved-license"><i class="sidebar-item-icon fa fa-thumbs-up" aria-hidden="true"></i>
                <span class="nav-label"> Approved License </span>
            </a>
        </li>
        <li [hidden]="sidebar['agencies']">
            <a class = "text-decoration-none"  routerLinkActive="active"  routerLink="/advertisement/agencies"><i class="sidebar-item-icon fa fa-dot-circle-o" aria-hidden="true"></i>
                <span class="nav-label"> Agencies </span>
            </a>
        </li>
        <li [hidden]="sidebar['manage-pricing']">
            <a class = "text-decoration-none"  routerLinkActive="active"  routerLink="/advertisement/manage-pricing"><i class="sidebar-item-icon fa fa-money" aria-hidden="true"></i>
                <span class="nav-label"> Manage Pricing </span>
            </a>
        </li>
        <li [hidden]="sidebar['places']">
            <a class = "text-decoration-none"  routerLinkActive="active"  routerLink="/advertisement/places"><i class="sidebar-item-icon fa fa-map-marker" aria-hidden="true"></i>
                <span class="nav-label"> Places </span>
            </a>
        </li>
        <li [hidden]="sidebar['gov-spaces']">
            <a class = "text-decoration-none"  routerLinkActive="active"  routerLink="/advertisement/gov-spaces"><i class="sidebar-item-icon fa fa-globe" aria-hidden="true"></i>
                <span class="nav-label"> Governement Spaces </span>
            </a>
        </li>
        <li [hidden]="sidebar['remove-ads']">
            <a class = "text-decoration-none"  routerLinkActive="active"  routerLink="/advertisement/remove-ads"><i class="sidebar-item-icon fa fa-ban" aria-hidden="true"></i>
                <span class="nav-label"> Remove Ads </span>
            </a>
        </li>
        <li [hidden]="sidebar['payment-invoices']">
            <a class = "text-decoration-none"  routerLinkActive="active"  routerLink="/advertisement/payment-invoices"><i class="sidebar-item-icon fa fa-credit-card" aria-hidden="true"></i>
                <span class="nav-label"> Payments </span>
            </a>
        </li>
        
       
      
     <li routerLinkActive="active" >
            <a class="text-decoration-none" [hidden]="sidebar['administration']" href="#" data-bs-toggle="collapse" data-bs-target="#collapseAdmin"
            aria-expanded="false" aria-controls="collapseAdmin"><i class="sidebar-item-icon fa fa-database"></i>
                <span class="nav-label">Administration</span><i class="fa fa-angle-left arrow"></i></a>
            <ul  class="nav-2-level collapse" id="collapseAdmin" data-bs-parent="#sidebar-collapse" >
              <div id="adminParent">
                 <li>
                    <a   class="text-decoration-none" [hidden]="sidebar['master_data']" href="#" data-bs-toggle="collapse" data-bs-target="#set"
                    aria-expanded="false" aria-controls="set" >
                        <span class="nav-label">Master Data</span><i class="fa fa-angle-left arrow"></i></a>
                    <ul  class="nav-3-level collapse" id="set" data-bs-parent="#adminParent" >



                        <li >
                            <a routerLink="/advertisement/advertisement-setting/code-value" routerLinkActive="active">Code Value</a>
                        </li>
                        <li >
                            <a routerLink="/advertisement/advertisement-setting/field" routerLinkActive="active">Field</a>
                        </li>
                        <li >
                            <a routerLink="/advertisement/advertisement-setting/hierachy" routerLinkActive="active">
                                Hierachy
                            </a>
                        </li>

                    </ul>
                </li>

                <li>
                    <a  lass="text-decoration-none" [hidden]="sidebar['security']" href="#" data-bs-toggle="collapse" data-bs-target="#sec"
                    aria-expanded="false" aria-controls="sec" >
                        <span class="nav-label">Security</span><i class="fa fa-angle-left arrow"></i></a>
                    <ul class="nav-3-level collapse" id="sec" data-bs-parent="#adminParent" >
                        <li>
                            <a  routerLink="/advertisement/administration/roles"
                                routerLinkActive="active">
                                Role
                            </a>
                        </li>
                        <li>
                            <a  routerLink="/advertisement/administration/users"
                                routerLinkActive="active">User</a>
                        </li>
                        <li>
                            <a  routerLink="/advertisement/administration/data-assignment"
                                routerLinkActive="active">
                                Data Assignment
                            </a>
                        </li>
                        <li>
                            <a  routerLink="/advertisement/administration/workflow"
                                routerLinkActive="active">
                                Workflow
                            </a>
                        </li>
                    </ul>
                </li>
              </div>
            </ul>
        </li> 


    </ul>
</div>
